/* eslint-disable */
export const zIndices = {
  zIndex99999: 99999, //For Barry icon fixed on controlD Page
  zIndex2: 2, // Button, Chatbubbles, End Chat Footer
  zIndex1: 1, // Tetarea, SplashScreen
  zIndex0: 0, // BarryBackground, TicketSent Icon
  'zIndex-1': -1, //Chatbackground
}

